/* ============ BKS SELLE CUSTOM V2 — moteur ============ */
(function(){
'use strict';
var root=document.getElementById('bkssc'); if(!root)return;
function $(id){return document.getElementById(id);}

/* ---------- données ---------- */
/* images hébergées sur Shopify Files (migrées depuis Netlify le 2026-07-10) */
var SCDN='https://cdn.shopify.com/s/files/1/0400/3086/3513/files/';
function im(n){return SCDN+'sc-'+n+'.webp';}
var BASE=300, PACK_PRIX=17.82;
var VAR={base:54119742275925,alcantara:54119750566229,nid:54119753220437,losange:54119754858837,pack:54119771603285,anti:54230426485077,supp20:54223741747541};
var MAIL='contact@bikesellier.fr', TEL='06 46 83 04 43';
var ADRESSE='<b>SARL GR France — Bike Sellier</b><br>Mickael Galaup<br>14 rue Beausoleil<br>66380 PIA — France<br>Tél. '+TEL;
var CLOUDINARY={cloud:'g7huv5sk',preset:'bks-photos'};/* hébergement photos clients (compte BKS) */

var TYPES=[['Moto','types-supermotard-moto'],['Scooter','types-scooter']];
var COUTS=[
 {k:'nid',n:"Nid d'abeille",p:60,img:im('styles-couture-nid-abeille')},
 {k:'losange',n:'Losange',p:35,img:im('styles-couture-losange')},
 {k:'none',n:'Sans décoration',p:0}
];
var MATS=[
 {k:'Simili cuir',lab:'Inclus',free:true,img:im('matieres-noir')},
 {k:'Alcantara',lab:'+ 80 €',img:im('matieres-alcantara-noir')},
 {k:'Antidérapant',lab:'+ 15 €',img:im('matieres-antiderapant')}
];
/* [nom, fichier, couleur de secours si l'image ne charge pas] */
var COLORS=[
 ['Noir','matieres-noir','#111111'],['Blanc','matieres-blanc','#f2f2f2'],['Gris','matieres-gris','#8c8c8c'],
 ['Rouge','matieres-rouge','#e2231a'],['Orange','matieres-orange','#e07b16'],['Jaune','matieres-jaune','#f2d20a'],
 ['Doré','matieres-dore','#c9a227'],['Vert','matieres-vert','#3bbf2a'],['Turquoise','matieres-turquoise','#1bb39a'],
 ['Bleu clair','matieres-bleu-clair','#37a0e0'],['Bleu','matieres-bleu','#1f4fd0'],
 ['Violet','matieres-violet','#7c3aed'],['Rose','matieres-rose','#e0249a'],['Bubble','matieres-bubble-noir','#1a1a1a']
];
var FILS=[
 ['Blanc','coutures-blanc','#f2f2f2'],['Noir','coutures-noir','#111111'],['Gris','coutures-gris','#8c8c8c'],
 ['Rouge','coutures-rouge','#e2231a'],['Orange','coutures-orange','#e07b16'],['Jaune','coutures-jaune','#f2d20a'],
 ['Jaune fluo','coutures-jaune-fluo','#d8f21a'],['Doré','coutures-dore','#c9a227'],['Vert','coutures-vert','#3bbf2a'],
 ['Turquoise','coutures-turquoise','#1bb39a'],['Bleu','coutures-bleu','#1f4fd0'],['Violet','coutures-violet','#7c3aed'],
 ['Rose','coutures-rose','#e0249a']
];
var BROD_PRICE=20;
var BROD_PH=['Pseudo','01','Ton texte…'];
var SLOTS=[['Couleur principale',true],['Couleur secondaire',true],['Couleur 3',false],['Couleur 4',false]];
var STEPS=[
 {ic:'🏍️',lb:'Ta moto',t:'Ta moto',s:'Tu enverras ta selle — indique juste ta machine.'},
 {ic:'🧵',lb:'Couture',t:'Le style de couture',s:'Le motif cousu et la couleur du fil.'},
 {ic:'🎨',lb:'Matières',t:'Les matières',s:'Tu peux en sélectionner plusieurs.'},
 {ic:'🌈',lb:'Couleurs',t:'Tes couleurs',s:'2 couleurs obligatoires, jusqu’à 4 au total.'},
 {ic:'✨',lb:'Broderie',t:'Tes broderies',s:'Écris ton texte et choisis la couleur du fil pour chacune.'},
 {ic:'📷',lb:'Ton projet',t:'Ton projet',s:'Raconte-nous le style que tu veux — c’est ce qui guide l’atelier.'},
 {ic:'🛒',lb:'Récap',t:'Options & récap',s:'Complète ton pack, puis vérifie tout.'}
];

/* ---------- état ---------- */
var st=blank(); var cur=0;
function blank(){return {type:'',marque:'',modele:'',annee:'',cout:'',fil:'',mats:{},cols:[null,null,null,null],brods:[{t:'',c:''},{t:'',c:''},{t:'',c:''}],desc:'',deco:false,pack:false,phMoto:[],phInspi:[],code:'',printed:''};}
/* empreinte de la config : si elle change apres impression, la feuille est perimee */
function cfgHash(){
  return JSON.stringify([st.type,st.marque,st.modele,st.annee,st.cout,st.fil,matsList(),
    st.cols,st.brods,st.desc,st.deco,st.pack,st.phMoto.length,st.phInspi.length]);
}
function sheetOk(){ return !!st.printed && st.printed===cfgHash(); }
function ensureCode(){
  if(!st.code)st.code='SC-'+(Date.now().toString(36)+Math.floor(Math.random()*1296).toString(36)).toUpperCase().slice(-7);
  return st.code;
}
/* pastille : la photo par-dessus la couleur de secours (jamais de pastille blanche) */
function swStyle(entry){return 'background-color:'+entry[2]+';background-image:url(\''+im(entry[1])+'\');';}
function coutObj(){for(var i=0;i<COUTS.length;i++)if(COUTS[i].k===st.cout)return COUTS[i];return null;}
function matsList(){return MATS.filter(function(m){return st.mats[m.k];}).map(function(m){return m.k;});}
function nbCols(){return st.cols.filter(Boolean).length;}
function brodFilled(){return st.brods.filter(function(b){return b.t.trim()!=='';});}
function brodCost(){return BROD_PRICE*brodFilled().length;}
function photosOk(){return !CLOUDINARY.cloud||st.phMoto.length>0;}
function total(){
  var t=BASE, co=coutObj();
  if(co)t+=co.p;
  if(st.mats['Alcantara'])t+=80;
  if(st.mats['Antidérapant'])t+=15;
  t+=brodCost();
  if(st.pack)t+=PACK_PRIX;
  return Math.round(t*100)/100;
}
function eur(n){return (n%1===0?String(n):n.toFixed(2).replace('.',','))+' €';}
function brodsOk(){return st.brods.every(function(b){return !b.t.trim()||b.c;});}
function motoOk(){return !!(st.type&&st.marque.trim()&&st.modele.trim()&&st.annee.trim());}
function configOk(){return motoOk()&&st.cout&&st.fil&&matsList().length>0&&st.cols[0]&&st.cols[1]&&brodsOk()&&st.desc.trim()!==''&&photosOk();}
function complete(){return configOk()&&sheetOk();}

/* ---------- scène de l'aperçu (contextuelle) ---------- */
var EXEMPLES=[1,2,3,4,5,6,7].map(function(i){return im('exemples-de-selles-exemple-'+i);});
var carIdx=0, carTimer=null;
function colEntry(n){for(var i=0;i<COLORS.length;i++)if(COLORS[i][0]===n)return COLORS[i];return null;}
function filEntry(n){for(var i=0;i<FILS.length;i++)if(FILS[i][0]===n)return FILS[i];return null;}
/* éclaircit / assombrit une couleur en gardant sa teinte */
function rgbOf(hex){return [parseInt(hex.slice(1,3),16),parseInt(hex.slice(3,5),16),parseInt(hex.slice(5,7),16)];}
function mix(hex,vers,part){
  var a=rgbOf(hex),b=rgbOf(vers);
  return 'rgb('+a.map(function(v,i){return Math.round(v+(b[i]-v)*part);}).join(',')+')';
}
/* relief de broderie : arête claire en haut, ombre en bas — les deux dans la TEINTE DU FIL.
   Le fil se détache par son relief, jamais par un contour d'une autre couleur. */
function brodStyle(hex){
  var haut=mix(hex,'#ffffff',0.42);   /* la lumière qui accroche le fil */
  var bas =mix(hex,'#000000',0.55);   /* l'ombre portée du fil sur le cuir */
  return 'color:'+hex+';text-shadow:0 -1.5px 0 '+haut+',0 1.5px 0 '+bas+',0 4px 8px rgba(0,0,0,.55);';
}
function stopCar(){ if(carTimer){clearInterval(carTimer);carTimer=null;} }
function badge(txt){ var b=$('sc-badge'); if(b)b.textContent=txt; }
function showImg(src,cap){
  stopCar();
  var s=$('sc-stage');
  var img=$('sc-img');
  if(!img){ s.innerHTML='<img id="sc-img" alt="Aperçu">'; img=$('sc-img'); }
  if(img.getAttribute('src')!==src){ img.classList.add('fade'); setTimeout(function(){img.src=src;img.classList.remove('fade');},160); }
  $('sc-cap').textContent=cap;
}
function startCar(){
  var s=$('sc-stage');
  if(!$('sc-img'))s.innerHTML='<img id="sc-img" src="'+EXEMPLES[carIdx]+'" alt="Réalisation Bike Sellier">';
  badge('NOS RÉALISATIONS');
  $('sc-cap').textContent='📷 Une de nos réalisations · photo non contractuelle';
  if(carTimer)return;
  carTimer=setInterval(function(){
    var img=$('sc-img'); if(!img){stopCar();return;}
    carIdx=(carIdx+1)%EXEMPLES.length;
    img.classList.add('fade');
    setTimeout(function(){img.src=EXEMPLES[carIdx];img.classList.remove('fade');},300);
  },4200);
}
function paintStage(){
  var s=$('sc-stage'); if(!s)return;
  var co=coutObj();

  /* étape couture : le motif choisi en grand */
  if(cur===1&&co&&co.img){ badge('TA COUTURE'); showImg(co.img,'🧵 Couture '+co.n.toLowerCase()); return; }

  /* étape matières : la texture de la dernière matière cochée */
  if(cur===2){
    var sel=MATS.filter(function(m){return st.mats[m.k]&&m.img;});
    if(sel.length){ badge('TA MATIÈRE'); showImg(sel[sel.length-1].img,'🎨 '+sel[sel.length-1].k); return; }
  }

  /* étape couleurs : les couleurs choisies en bandes */
  if(cur===3){
    stopCar();
    var html='<div class="bands">';
    SLOTS.forEach(function(sl,i){
      var c=st.cols[i]?colEntry(st.cols[i]):null;
      if(c)html+='<div class="band" style="background-color:'+c[2]+';background-image:url(\''+im(c[1])+'\')"><span class="bl">'+sl[0]+' · '+c[0]+'</span></div>';
      else if(sl[1])html+='<div class="band empty"><span class="bl">'+sl[0]+' — à choisir</span></div>';
    });
    html+='</div>';
    s.innerHTML=html;
    badge('TES COULEURS');
    $('sc-cap').textContent='🌈 Tes couleurs, dans l’ordre';
    return;
  }

  /* étape broderie : le texte, dans le fil choisi, posé sur la couleur principale de la selle */
  if(cur===4){
    var bl=brodFilled();
    if(bl.length){
      stopCar();
      var mc=st.cols[0]?colEntry(st.cols[0]):null;
      /* un reflet en haut à gauche donne du grain au cuir : le relief du fil devient lisible */
      var sheen='radial-gradient(ellipse at 30% 18%,rgba(255,255,255,.20),rgba(0,0,0,.30) 70%)';
      var patch=mc
        ? 'background-color:'+mc[2]+';background-image:'+sheen+',url(\''+im(mc[1])+'\');'
        : 'background-image:'+sheen+',linear-gradient(135deg,#3a3a3e,#1b1b1f 60%,#43434a);';
      s.innerHTML='<div class="brodpatch" style="'+patch+'">'+bl.map(function(b){
        var f=b.c?filEntry(b.c):null;
        return '<div class="brodline" style="'+brodStyle(f?f[2]:'#ffffff')+'">'+b.t.trim().replace(/</g,'&lt;')+'</div>';
      }).join('')+'</div>';
      badge('TES BRODERIES');
      $('sc-cap').textContent=mc?('✨ Rendu sur ta couleur principale · '+mc[0]):'✨ Aperçu du rendu de tes broderies';
      return;
    }
  }

  /* par défaut : carrousel des réalisations */
  startCar();
}

/* ---------- aperçu ---------- */
function paintPrev(){
  var bt=brodFilled().map(function(b){return b.t.trim();});
  $('sc-ident').innerHTML=bt.length?bt.slice(0,2).join(' · '):'&nbsp;';
  $('sc-wm').textContent=st.marque.trim()||'TA SELLE';
  var md=[st.modele.trim(),st.annee.trim()].filter(Boolean).join(' · ');
  $('sc-mdl').innerHTML=md||'&nbsp;';
  var colNames=st.cols.filter(Boolean);
  var rows=[
    ['sc-f1',motoOk(),(st.marque+' '+st.modele).trim()],
    ['sc-f2',st.cout&&st.fil,(coutObj()?coutObj().n:'')+(st.fil?' · fil '+st.fil:'')],
    ['sc-f3',matsList().length,matsList().join(' + ')],
    ['sc-f4',colNames.length,colNames.join(' + ')],
    ['sc-f5',brodFilled().length,brodFilled().length+' broderie(s)'],
    ['sc-f6',st.desc.trim()&&photosOk(),'descriptif ✓'+((st.phMoto.length+st.phInspi.length)?' · '+(st.phMoto.length+st.phInspi.length)+' photo(s)':'')]
  ];
  rows.forEach(function(r){var e=$(r[0]);if(!e)return;e.classList.toggle('ok',!!r[1]);e.querySelector('b').textContent=r[1]?r[2]:'—';});
  $('sc-tot').textContent=eur(total());
  var m=$('sc-mtot'); if(m)m.textContent=eur(total());
  /* le bouton reste actif dès que la config est bonne : si la feuille n'est pas
     imprimée, on le dit avec un message d'erreur (plus clair qu'un bouton grisé) */
  var c=$('sc-cta');
  c.disabled=!configOk();
  c.textContent=configOk()?('🛒 Ajouter au panier — '+eur(total())):'Termine ta config pour ajouter';
  paintStage();
}

/* ---------- rendu des étapes ---------- */
function card(sel,html,fn){var d=document.createElement('div');d.className='vc'+(sel?' sel':'');d.innerHTML=html;d.onclick=fn;return d;}
function err(msg){var e=$('sc-err');if(msg){e.textContent='⚠️ '+msg;e.style.display='block';}else{e.style.display='none';}}

function render(){
  var S=STEPS[cur];
  $('sc-sn').textContent='Étape '+(cur+1)+' sur '+STEPS.length;
  $('sc-tstep').textContent='Étape '+(cur+1)+'/'+STEPS.length+' · '+S.lb;
  $('sc-st').textContent=S.t;
  $('sc-ss').textContent=S.s;
  $('sc-bp').disabled=(cur===0);
  $('sc-bn').textContent=(cur===STEPS.length-1)?'🛒 Ajouter au panier':'Suivant →';
  err(null);
  var p=$('sc-pane'); p.innerHTML='';

  /* --- 0 · ta moto --- */
  if(cur===0){
    p.innerHTML='<label class="lb">Type de machine</label><div class="grid gg2" id="sc-tp"></div>'
      +'<div class="g3i" style="margin-top:4px">'
      +'<div><label class="lb">Marque</label><input type="text" id="sc-mk" placeholder="Aprilia, Yamaha, Beta…"></div>'
      +'<div><label class="lb">Modèle</label><input type="text" id="sc-md" placeholder="SX 50"></div>'
      +'<div><label class="lb">Année</label><input type="text" id="sc-an" placeholder="2020"></div></div>';
    var tp=$('sc-tp');
    TYPES.forEach(function(t){
      tp.appendChild(card(st.type===t[0],'<div class="th thbig" style="background-image:url(\''+im(t[1])+'\')"></div><div class="tx"><div class="n">'+t[0]+'</div></div><div class="chk">✓</div>',
        function(){st.type=t[0];render();paintPrev();}));
    });
    $('sc-mk').value=st.marque; $('sc-mk').oninput=function(){st.marque=this.value;paintPrev();};
    $('sc-md').value=st.modele; $('sc-md').oninput=function(){st.modele=this.value;paintPrev();};
    $('sc-an').value=st.annee;  $('sc-an').oninput=function(){st.annee=this.value;paintPrev();};
  }

  /* --- 1 · couture + fil --- */
  if(cur===1){
    var g=document.createElement('div'); g.className='grid gg3';
    COUTS.forEach(function(c){
      var th=c.img?'<div class="th" style="height:110px;background-image:url(\''+c.img+'\')"></div>':'<div class="th none-th" style="height:110px">Pas de motif cousu</div>';
      var pl=c.p?'<div class="p pay">+ '+c.p+' €</div>':(c.k==='none'?'<div class="p">Pas de motif cousu sur la selle</div>':'');
      g.appendChild(card(st.cout===c.k,th+'<div class="tx"><div class="n">'+c.n+'</div>'+pl+'</div><div class="chk">✓</div>',
        function(){st.cout=c.k;render();paintPrev();}));
    });
    p.appendChild(g);
    var lb=document.createElement('label'); lb.className='lb'; lb.textContent='Couleur du fil de couture'; p.appendChild(lb);
    var fl=document.createElement('div'); fl.className='sws';
    FILS.forEach(function(f){
      var w=document.createElement('div'); w.className='swwrap';
      var d=document.createElement('div'); d.className='sw'+(st.fil===f[0]?' sel':'');
      d.setAttribute('style',swStyle(f)); d.title=f[0];
      d.onclick=function(){st.fil=f[0];render();paintPrev();};
      var l=document.createElement('div'); l.className='swlab'; l.textContent=f[0];
      w.appendChild(d); w.appendChild(l); fl.appendChild(w);
    });
    p.appendChild(fl);
  }

  /* --- 2 · matières (multi) --- */
  if(cur===2){
    var g2=document.createElement('div'); g2.className='grid gg4';
    MATS.forEach(function(m){
      var th='<div class="th" style="background-image:url(\''+m.img+'\')"></div>';
      var pl=m.free?'<div class="p free">'+m.lab+'</div>':'<div class="p pay">'+m.lab+'</div>';
      g2.appendChild(card(!!st.mats[m.k],th+'<div class="tx"><div class="n">'+m.k+'</div>'+pl+'</div><div class="chk">✓</div>',
        function(){st.mats[m.k]=!st.mats[m.k];render();paintPrev();}));
    });
    p.appendChild(g2);
    var n2=document.createElement('p'); n2.className='note'; n2.style.marginTop='14px';
    n2.innerHTML='Tu peux combiner plusieurs matières (ex : dessus alcantara + assise antidérapante). Tu préciseras où va chaque matière à l’étape « Ton projet ».<br>💡 Alcantara dispo en : noir, bleu foncé, jaune, orange, violet.';
    p.appendChild(n2);
  }

  /* --- 3 · couleurs --- */
  if(cur===3){
    var n3=document.createElement('p'); n3.className='note';
    n3.textContent='Toutes les couleurs existent en similicuir. Re-clique une couleur pour la retirer.';
    p.appendChild(n3);
    SLOTS.forEach(function(sl,idx){
      var row=document.createElement('div'); row.className='zone';
      row.innerHTML='<div class="zn">'+sl[0]+(sl[1]?' <span class="req">*</span>':'<small>optionnel</small>')+'</div>';
      var sws=document.createElement('div'); sws.className='sws';
      COLORS.forEach(function(c){
        var w=document.createElement('div'); w.className='swwrap';
        var d=document.createElement('div'); d.className='sw'+(st.cols[idx]===c[0]?' sel':'');
        d.setAttribute('style',swStyle(c)); d.title=c[0];
        d.onclick=function(){
          st.cols[idx]=(st.cols[idx]===c[0])?null:c[0];
          render(); paintPrev();
        };
        var l=document.createElement('div'); l.className='swlab'; l.textContent=c[0];
        w.appendChild(d); w.appendChild(l); sws.appendChild(w);
      });
      row.appendChild(sws); p.appendChild(row);
    });
  }

  /* --- 4 · broderies --- */
  if(cur===4){
    var h='<div class="promo">✨ <b>20 € par broderie</b> — pseudo, numéro de pilote, surnom… écris exactement ce que tu veux.</div>'
      +'<p class="note">Écris exactement ce que tu veux broder (pseudo, numéro, surnom…), puis choisis la couleur du fil de <b>cette</b> broderie. Laisse vide si tu n’en veux pas.</p>';
    for(var i=0;i<3;i++){
      h+='<div class="brod"><div class="bt"><span>Broderie '+(i+1)+'</span><span class="bp">'+BROD_PRICE+' €</span></div>'
        +'<input type="text" id="sc-b'+i+'" maxlength="30" placeholder="'+BROD_PH[i]+'">'
        +'<div class="bsws" id="sc-bs'+i+'"></div><div class="bhint" id="sc-bh'+i+'"></div></div>';
    }
    h+='<p class="note">📎 Un <b>logo</b> à broder ? Envoie-le par email juste après ta commande (le rappel est sur ta feuille colis).</p>';
    p.innerHTML=h;
    function paintBrod(k){
      var sws=$('sc-bs'+k);
      for(var x=0;x<FILS.length;x++)sws.children[x].className='sw mini'+(st.brods[k].c===FILS[x][0]?' sel':'');
      sws.style.display=st.brods[k].t.trim()?'flex':'none';
      $('sc-bh'+k).textContent=(st.brods[k].t.trim()&&!st.brods[k].c)?'→ choisis la couleur du fil de cette broderie':'';
    }
    for(var j=0;j<3;j++){
      (function(k){
        var inp=$('sc-b'+k);
        inp.value=st.brods[k].t;
        inp.oninput=function(){st.brods[k].t=this.value;paintBrod(k);paintPrev();};
        var sws=$('sc-bs'+k);
        FILS.forEach(function(f){
          var d=document.createElement('div'); d.className='sw mini';
          d.setAttribute('style',swStyle(f)); d.title=f[0];
          d.onclick=function(){st.brods[k].c=f[0];paintBrod(k);paintPrev();};
          sws.appendChild(d);
        });
        paintBrod(k);
      })(j);
    }
  }

  /* --- 5 · ton projet --- */
  if(cur===5){
    p.innerHTML='<label class="lb">Explique-moi ta selle <span class="req">* obligatoire</span></label>'
      +'<p class="note">Décris l’<b>ambiance</b> que tu veux (agressive, sobre, racing, vintage, discrète…) et <b>où va chaque couleur ou matière</b>.</p>'
      +'<textarea id="sc-ds" maxlength="600" placeholder="Ex : je veux un rendu agressif — dessus en alcantara noir, côtés rouges, une fine bande blanche au milieu, assise antidérapante, et mon pseudo brodé à l’arrière."></textarea>'
      +'<div id="sc-photos"></div>'
      +'<label class="chkline"><input type="checkbox" id="sc-deco"> J’ajoute une <b>planche déco</b> imprimée dans mon colis (gratuit)</label>'
      +'<div class="deco-msg" id="sc-decomsg">ℹ️ Fais imprimer une <b>planche déco spéciale selle</b> chez ton imprimeur et joins-la dans le colis avec ta selle — on la pose pour toi, c’est offert.<br>⚠️ Ce n’est <b>pas</b> le kit déco de ta moto : c’est bien la planche imprimée prévue pour la selle.</div>';
    var ds=$('sc-ds'); ds.value=st.desc;
    ds.oninput=function(){st.desc=this.value;paintPrev();};
    var dc=$('sc-deco'); dc.checked=st.deco;
    dc.onchange=function(){st.deco=this.checked;$('sc-decomsg').classList.toggle('on',this.checked);paintPrev();};
    $('sc-decomsg').classList.toggle('on',st.deco);
    buildPhotos($('sc-photos'));
  }

  /* --- 6 · options & récap --- */
  if(cur===6){
    var r=document.createElement('div'); r.className='recap';
    r.innerHTML='<div style="font-size:11.5px;font-weight:800;letter-spacing:.6px;color:#7a7a80;text-transform:uppercase;margin-bottom:8px">Récapitulatif</div>'
      +recapLines().map(function(l){return '<div class="rr"><span>'+l[0]+'</span><b>'+l[1]+'</b></div>';}).join('')
      +'<div class="rr" style="margin-top:6px;border-top:2px solid #eee;padding-top:9px;font-size:16px"><b>TOTAL</b><b>'+eur(total())+'</b></div>';
    p.appendChild(r);

    var sv=document.createElement('div'); sv.className='savebox';
    sv.innerHTML='<div class="sb-t">💾 Pas prêt à commander ?</div>'
      +'<div class="sb-s">Sauvegarde ta config : copie ton lien de reprise, ou envoie-le-toi par email.</div>'
      +'<div class="sb-row"><button type="button" id="sc-savelink" style="flex:1;background:#8B5CF6;color:#fff;border:none;border-radius:10px;padding:12px;font-weight:800;cursor:pointer;font-size:13.5px;font-family:inherit">🔗 Copier mon lien</button>'
      +'<button type="button" id="sc-savemail" style="flex:1;background:none;border:1.5px solid #8B5CF6;color:#8B5CF6;border-radius:10px;padding:12px;font-weight:800;cursor:pointer;font-size:13.5px;font-family:inherit">✉️ Me l’envoyer par email</button></div>'
      +'<div class="sb-ok" id="sc-saveok"></div>';
    p.appendChild(sv);
    $('sc-savelink').onclick=function(){
      var url=saveUrl();
      try{ navigator.clipboard.writeText(url).then(function(){$('sc-saveok').textContent='✓ Lien copié ! Garde-le précieusement.';},function(){$('sc-saveok').textContent=url;}); }
      catch(e){ $('sc-saveok').textContent=url; }
    };
    $('sc-savemail').onclick=function(){
      var url=saveUrl();
      window.location.href='mailto:?subject='+encodeURIComponent('Ma selle custom BKS — lien de reprise')+'&body='+encodeURIComponent('Reprends ta configuration ici :\n\n'+url);
    };

    /* étape OBLIGATOIRE : imprimer la feuille colis */
    var done=sheetOk(), perime=(st.printed&&!done);
    var sh=document.createElement('div'); sh.className='shipbox sheetreq'+(done?' done':'');
    sh.innerHTML='<div class="sb-t">'+(done?'✅ Ta feuille colis est prête':'📄 Étape obligatoire — ta feuille colis')+'</div>'
      +'<div class="sb-s">'+(done
        ? 'Garde-la précieusement : elle doit être <b>dans le carton, avec ta selle</b>. Tu peux la réimprimer à tout moment.'
        : 'Sans cette feuille dans ton colis, <b>impossible d’identifier ta selle</b> à l’atelier. Imprime-la (ou enregistre-la en PDF) avant de commander.')
      +'</div>'
      +(perime?'<div class="sb-warn">⚠️ Tu as modifié ta config depuis l’impression — réimprime ta feuille colis.</div>':'')
      +'<ol><li>Tu imprimes ta <b>feuille colis</b> (n° de selle + récap + notre adresse)</li>'
      +'<li>Tu valides ta commande, puis tu notes ton <b>nom</b> et ton <b>n° de commande</b> au stylo sur la feuille</li>'
      +'<li>Tu emballes ta selle et tu <b>glisses la feuille dans le carton</b></li>'
      +'<li>Tu nous envoies le colis à <b>Pia (66380)</b> — l’adresse est sur la feuille</li>'
      +'<li>On fabrique et on te renvoie ta selle 💪</li></ol>'
      +'<button type="button" class="'+(done?'linkbtn':'bigbtn')+'" id="sc-sheetbtn">🖨️ '+(done?'Réimprimer ma feuille colis':'Imprimer ma feuille colis')+'</button>';
    p.appendChild(sh);
    $('sc-sheetbtn').onclick=function(){
      var e=firstInvalid();
      if(e>=0){ cur=e; render(); paintPrev(); err(validate(e)); return; }
      showSheet(ensureCode(),false);
    };

    /* upsell pack entretien — placé À LA FIN, juste avant l'ajout au panier */
    var up=document.createElement('div'); up.className='upsell'; up.style.marginTop='16px';
    up.innerHTML='<div class="ubadge">🔥 -10% à ne pas manquer</div>'
      +'<div class="uimg" style="background-image:url(\''+im('accessoires-pack-nettoyage')+'\')"></div>'
      +'<div class="ubody"><div class="utitle">Pack entretien — garde ta selle comme au premier jour ✨</div>'
      +'<div class="udesc">2 microfibres + nettoyant simili/alcantara + nourrissant simili.</div>'
      +'<div><span class="uold">19,80 €</span><span class="unew">17,82 €</span></div></div>'
      +'<button type="button" class="ubtn" id="sc-packbtn">'+(st.pack?'✓ Ajouté':'+ Ajouter')+'</button>';
    p.appendChild(up);
    var pb=up.querySelector('#sc-packbtn');
    if(st.pack)pb.classList.add('added');
    pb.onclick=function(){st.pack=!st.pack;render();paintPrev();};
  }

  /* rail */
  var rl=$('sc-rail'); rl.innerHTML='';
  STEPS.forEach(function(s,i){
    var d=document.createElement('button'); d.type='button';
    d.className='rstep'+(i===cur?' act':'')+(i<cur?' done':'');
    d.innerHTML='<span class="ic">'+s.ic+'</span><span class="lbb">'+s.lb+'</span>';
    d.onclick=function(){cur=i;render();paintPrev();};
    rl.appendChild(d);
  });
}

/* ---------- photos (upload direct) ---------- */
function buildPhotos(el){
  if(!el)return;
  if(!CLOUDINARY.cloud){
    el.innerHTML='<div class="photobox">📷 <b>Tes photos (indispensables)</b> : juste après ta commande, envoie par email <b>des photos de ta moto</b> + tes <b>photos d’inspiration</b> (selles ou styles que tu aimes), avec ton <b>n° de selle</b> en objet. Le rappel avec l’adresse email est sur ta feuille colis et dans ton email de confirmation.</div>';
    return;
  }
  el.innerHTML='<label class="lb">Photos de ta moto <span class="req">* obligatoire</span></label>'
    +'<div class="upzone" id="sc-upm">📷 Clique pour ajouter des photos de ta moto</div>'
    +'<input type="file" id="sc-fm" accept="image/*" multiple style="display:none">'
    +'<div class="upthumbs" id="sc-tm"></div><div class="uperr" id="sc-em"></div>'
    +'<label class="lb">Photos d’inspiration <small style="text-transform:none;font-weight:600">(optionnel)</small></label>'
    +'<div class="upzone" id="sc-upi">🖼️ Selles ou styles qui t’inspirent</div>'
    +'<input type="file" id="sc-fi" accept="image/*" multiple style="display:none">'
    +'<div class="upthumbs" id="sc-ti"></div><div class="uperr" id="sc-ei"></div>';
  wireUp('sc-upm','sc-fm','sc-tm','sc-em','phMoto','📷 Ajouter d’autres photos de ta moto');
  wireUp('sc-upi','sc-fi','sc-ti','sc-ei','phInspi','🖼️ Ajouter d’autres inspirations');
}
function wireUp(zid,fid,tid,eid,key,more){
  var z=$(zid),f=$(fid);
  z.onclick=function(){f.click();};
  f.onchange=function(){uploadFiles(this.files,key,tid,eid,zid,more);this.value='';};
  if(st[key].length)z.textContent=more;
  paintThumbs(key,tid);
}
function paintThumbs(key,tid){
  var t=$(tid); if(!t)return;
  t.innerHTML=st[key].map(function(u2,i){
    return '<span class="upth"><img src="'+u2.replace('/upload/','/upload/w_150,h_150,c_fill/')+'" alt="photo"><button type="button" data-k="'+key+'" data-i="'+i+'" class="uprm">✕</button></span>';
  }).join('');
  Array.prototype.forEach.call(t.querySelectorAll('.uprm'),function(b){
    b.onclick=function(){
      st[b.getAttribute('data-k')].splice(+b.getAttribute('data-i'),1);
      paintThumbs(b.getAttribute('data-k'),tid);paintPrev();
    };
  });
}
function uploadFiles(files,key,tid,eid,zid,more){
  var e=$(eid),z=$(zid); e.textContent='';
  var room=Math.max(0,6-st[key].length);
  var list=Array.prototype.slice.call(files).slice(0,room);
  if(!list.length){e.textContent='⚠️ Maximum 6 photos.';return;}
  var done=0;
  z.textContent='⏳ Envoi en cours… 0/'+list.length;
  list.forEach(function(file){
    if(file.size>10*1024*1024){
      done++;e.textContent='⚠️ Photo trop lourde (max 10 Mo) : '+file.name;
      if(done>=list.length)z.textContent=more;
      return;
    }
    var fd=new FormData();
    fd.append('file',file);
    fd.append('upload_preset',CLOUDINARY.preset);
    fetch('https://api.cloudinary.com/v1_1/'+CLOUDINARY.cloud+'/image/upload',{method:'POST',body:fd})
      .then(function(r){return r.json();})
      .then(function(j){
        done++;
        if(j&&j.secure_url)st[key].push(j.secure_url);
        else e.textContent='⚠️ Envoi impossible, réessaie.';
        z.textContent=done<list.length?('⏳ Envoi en cours… '+done+'/'+list.length):more;
        paintThumbs(key,tid);paintPrev();
      })
      .catch(function(){
        done++;e.textContent='⚠️ Envoi impossible, vérifie ta connexion et réessaie.';
        if(done>=list.length)z.textContent=more;
      });
  });
}

/* ---------- récap ---------- */
function recapLines(){
  var L=[['Selle custom (base)',eur(BASE)]];
  if(st.type)L.push(['Type',st.type]);
  var machine=[st.marque,st.modele,st.annee].filter(function(x){return x&&x.trim();}).join(' ');
  if(machine)L.push(['Machine',machine]);
  var co=coutObj();
  if(co)L.push(['Couture : '+co.n,co.p?eur(co.p):'—']);
  if(st.fil)L.push(['Fil de couture',st.fil]);
  matsList().forEach(function(m){
    var pr=m==='Alcantara'?eur(80):(m==='Antidérapant'?eur(15):'Inclus');
    L.push(['Matière : '+m,pr]);
  });
  var cn=st.cols.filter(Boolean);
  if(cn.length)L.push(['Couleurs',cn.join(' + ')]);
  brodFilled().forEach(function(b){
    L.push(['Broderie « '+b.t.trim()+' »'+(b.c?' — fil '+b.c:''),eur(BROD_PRICE)]);
  });
  if(st.phMoto.length||st.phInspi.length)L.push(['Photos jointes',String(st.phMoto.length+st.phInspi.length)]);
  if(st.deco)L.push(['Planche déco','Offert']);
  if(st.pack)L.push(['Pack entretien (-10%)',eur(PACK_PRIX)]);
  return L;
}

/* ---------- sauvegarde par lien ---------- */
function saveUrl(){
  var data=JSON.stringify(st);
  var b64=btoa(unescape(encodeURIComponent(data)));
  return location.origin+location.pathname+'#cfg='+encodeURIComponent(b64);
}
function tryRestore(){
  if(location.hash.indexOf('#cfg=')!==0)return;
  try{
    var b64=decodeURIComponent(location.hash.slice(5));
    var data=JSON.parse(decodeURIComponent(escape(atob(b64))));
    if(data&&typeof data==='object'){
      var b=blank();
      for(var k in b)if(data[k]!==undefined)b[k]=data[k];
      if(!(b.brods instanceof Array)||b.brods.length!==3)b.brods=blank().brods;
      if(!(b.cols instanceof Array)||b.cols.length!==4)b.cols=blank().cols;
      st=b; cur=6;
    }
  }catch(e){}
}

/* ---------- feuille colis ---------- */
/* le contenu de la feuille, sans les boutons : sert à la fois à la fenêtre et à l'impression */
function sheetBoxes(code){
  var mail=MAIL;
  var lines=recapLines().map(function(l){return '<div class="rr"><span>'+l[0]+'</span><b>'+l[1]+'</b></div>';}).join('');
  var adr=ADRESSE?ADRESSE:'📧 L’adresse d’envoi est indiquée dans ton <b>email de confirmation de commande</b>.';
  return '<h3>BKS · BIKE SELLIER</h3>'
    +'<div class="sh-sub">Feuille colis — à glisser dans ton carton</div>'
    +'<div class="sh-box"><div class="sh-l">N° de selle</div><b style="font-size:18px">'+code+'</b></div>'
    +'<div class="sh-box fill"><div class="sh-l">✍️ À remplir au stylo, après ton paiement</div>'
      +'<div class="fl"><span>Nom et prénom</span><i></i></div>'
      +'<div class="fl"><span>N° de commande</span><i></i></div>'
      +'<div class="fh">Ton n° de commande (ex. #BKS16001) est sur ton email de confirmation.</div></div>'
    +'<div class="sh-box"><div class="sh-l">Machine</div>'+((st.marque+' '+st.modele+' '+st.annee).trim()||'—')+'</div>'
    +'<div class="sh-box"><div class="sh-l">Ta configuration</div>'+lines
    +'<div class="rr" style="border-top:2px solid #eee;margin-top:4px;padding-top:7px"><b>TOTAL</b><b>'+eur(total())+'</b></div></div>'
    +(st.desc.trim()?'<div class="sh-box"><div class="sh-l">Ton descriptif</div>'+st.desc.trim().slice(0,400).replace(/</g,'&lt;')+'</div>':'')
    +'<div class="sh-box hi"><div class="sh-l" style="color:#8B5CF6">Où envoyer ta selle ?</div>'+adr+'<div style="font-size:11.5px;color:#8a8a90;margin-top:6px">Glisse cette feuille dans le colis, avec ta selle.</div></div>'
    +((st.phMoto.length||st.phInspi.length)
      ?'<div class="sh-box hi"><div class="sh-l" style="color:#8B5CF6">Tes photos</div>✓ Déjà jointes à ta commande ('+(st.phMoto.length+st.phInspi.length)+' photo(s))</div>'
      :'<div class="sh-box hi"><div class="sh-l" style="color:#8B5CF6">Tes photos</div>Envoie tes photos (moto + inspiration) à <b>'+mail+'</b> avec l’objet : <b>'+code+'</b></div>')
    +'<div style="font-size:11.5px;color:#8a8a90;margin-top:8px">⚠️ Sans cette feuille dans le colis, impossible d’identifier ta selle : ne l’oublie pas !</div>';
}
function sheetHTML(code,afterAdd){
  return '<div class="sheet" id="bkssheet">'+sheetBoxes(code)
    +'<div class="sh-actions"><button type="button" class="sh-print" id="sc-shprint">🖨️ Imprimer / Enregistrer en PDF</button>'
    +(afterAdd?'<button type="button" class="sh-cart" onclick="window.location.href=\'/cart\'">Aller au panier →</button>':'')
    +'<button type="button" class="sh-close" id="sc-shclose">Fermer</button></div>'
    +'</div>';
}
/* document autonome : sur mobile, l'astuce CSS @media print ne sort qu'une page blanche */
function printDoc(code){
  var css='*{box-sizing:border-box}'
    +'body{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;color:#1c1c1e;margin:0;padding:22px 20px;background:#fff;max-width:640px;}'
    +'h3{font-size:20px;font-weight:900;letter-spacing:2px;margin:0;}'
    +'.sh-sub{font-size:11px;font-weight:800;letter-spacing:1.2px;color:#8B5CF6;text-transform:uppercase;margin:3px 0 16px;}'
    +'.sh-box{border:1.5px dashed #bbb;border-radius:8px;padding:11px 13px;margin:10px 0;font-size:13.5px;}'
    +'.sh-box.hi{border-color:#8B5CF6;border-style:solid;}'
    +'.sh-l{font-size:10px;font-weight:800;letter-spacing:.8px;color:#8a8a90;text-transform:uppercase;margin-bottom:4px;}'
    +'.rr{display:flex;justify-content:space-between;gap:14px;font-size:13px;padding:4px 0;border-bottom:1px solid #f0f0f2;}'
    +'.rr:last-child{border:none}.rr b{white-space:nowrap}'
    +'.sh-box.fill{border-color:#E11D2A;border-style:solid;}'
    +'.fl{display:flex;align-items:flex-end;gap:10px;margin:11px 0 4px;}'
    +'.fl span{font-size:12px;color:#6b6b70;white-space:nowrap;}'
    +'.fl i{flex:1;border-bottom:1.5px solid #333;height:19px;}'
    +'.fh{font-size:10.5px;color:#8a8a90;margin-top:7px;}'
    +'.pbar{position:sticky;top:0;background:#fff;padding-bottom:14px;display:flex;gap:10px;}'
    +'.pbar button{flex:1;border:none;border-radius:9px;padding:13px;font-weight:800;font-size:14px;cursor:pointer;font-family:inherit;}'
    +'.pb1{background:#E11D2A;color:#fff}.pb2{background:#eee;color:#444}'
    +'@media print{.pbar{display:none!important}body{padding:0}}';
  return '<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8">'
    +'<meta name="viewport" content="width=device-width,initial-scale=1">'
    +'<title>Feuille colis '+code+'</title><style>'+css+'</style></head><body>'
    +'<div class="pbar"><button class="pb1" onclick="window.print()">🖨️ Imprimer / Enregistrer en PDF</button>'
    +'<button class="pb2" onclick="window.close()">Fermer</button></div>'
    +sheetBoxes(code)+'</body></html>';
}
/* mark=false : simple réimpression après l'ajout au panier, ça ne valide aucune nouvelle config */
function printSheet(code,mark){
  if(mark!==false)st.printed=cfgHash();
  var w=null;
  try{ w=window.open('','_blank'); }catch(e){}
  if(w&&w.document){
    w.document.open();
    w.document.write(printDoc(code));
    w.document.close();
    var go=function(){ try{ w.focus(); w.print(); }catch(e){} };
    if(w.document.readyState==='complete')setTimeout(go,250); else w.onload=go;
  }else{
    window.print();                /* repli si le navigateur bloque la fenêtre */
  }
  $('bksmodal').classList.remove('on');
  render(); paintPrev();
}
function showSheet(code,afterAdd){
  var m=$('bksmodal');
  m.innerHTML=sheetHTML(code,afterAdd);
  m.classList.add('on');
  $('sc-shclose').onclick=function(){m.classList.remove('on');};
  $('sc-shprint').onclick=function(){ printSheet(code,!afterAdd); };
}
function showOk(code){
  var m=$('bksmodal');
  m.innerHTML='<div class="sheet" id="bkssheet"><div class="okt">✅ Ta selle est dans le panier !</div>'
    +'<div class="oks">Ton n° de selle : <b>'+code+'</b><br>1️⃣ Ta <b>feuille colis est imprimée</b> ✓<br>2️⃣ Finalise ta commande 👇<br>3️⃣ <b>Note ton nom et ton n° de commande</b> au stylo sur la feuille<br>4️⃣ '+((st.phMoto.length||st.phInspi.length)?'Tes photos sont déjà jointes ✓ — ':'Envoie tes photos à '+MAIL+' avec ce n°, puis ')+'glisse la feuille dans le carton avec ta selle</div>'
    +'<div class="sh-actions"><button type="button" class="sh-print" id="sc-okprint">🖨️ Revoir ma feuille</button>'
    +'<button type="button" class="sh-cart" onclick="window.location.href=\'/cart\'">Aller au panier →</button></div></div>';
  m.classList.add('on');
  $('sc-okprint').onclick=function(){showSheet(code,true);};
}

/* ---------- panier (bundle protégé) ---------- */
function buildProps(code){
  var p={};
  p['N° selle']=code;
  p['Type']=st.type; p['Marque']=st.marque; p['Modèle']=st.modele; p['Année']=st.annee;
  var co=coutObj(); if(co)p['Couture']=co.n;
  if(st.fil)p['Fil couture']=st.fil;
  p['Matières']=matsList().join(' + ');
  st.cols.forEach(function(c,i){if(c)p['Couleur '+(i+1)]=c;});
  brodFilled().forEach(function(b,i){p['Broderie '+(i+1)]='« '+b.t.trim()+' »'+(b.c?' — fil '+b.c:'');});
  p['Descriptif']=st.desc.trim();
  if(st.deco)p['Planche déco']='Oui — fournie par le client dans le colis';
  st.phMoto.forEach(function(url,i){p['Photo moto '+(i+1)]=url;});
  st.phInspi.forEach(function(url,i){p['Photo inspiration '+(i+1)]=url;});
  if(!st.phMoto.length&&!st.phInspi.length)p['Photos']='À envoyer par email avec le n° de selle';
  return p;
}
function checkout(){
  if(!complete())return;
  var code=ensureCode();
  var supps=[];
  if(st.mats['Alcantara'])supps.push({id:VAR.alcantara,quantity:1,properties:{'Détail':'Alcantara'}});
  if(st.mats['Antidérapant'])supps.push({id:VAR.anti,quantity:1,properties:{'Détail':'Antidérapant'}});
  if(st.cout==='nid')supps.push({id:VAR.nid,quantity:1,properties:{'Détail':"Couture nid d'abeille"}});
  if(st.cout==='losange')supps.push({id:VAR.losange,quantity:1,properties:{'Détail':'Couture losange'}});
  brodFilled().forEach(function(b,i){
    supps.push({id:VAR.supp20,quantity:1,properties:{'Détail':'Broderie '+(i+1)+' « '+b.t.trim().slice(0,24)+' »','_bks_slot':'b'+(i+1)}});
  });
  var bp=buildProps(code);
  bp['_bks_id']=code; bp['_bks_role']='base'; bp['_bks_parts']=String(1+supps.length);
  var items=[{id:VAR.base,quantity:1,properties:bp}];
  supps.forEach(function(s){s.properties['_bks_id']=code;s.properties['_bks_role']='supp';items.push(s);});
  if(st.pack)items.push({id:VAR.pack,quantity:1});
  var bn=$('sc-bn'), cta=$('sc-cta');
  bn.disabled=true; cta.disabled=true; bn.textContent='Ajout en cours…';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){
      if(!r.ok)throw new Error('add');
      /* la selle est au panier : on repart d'un n° neuf, sinon une 2e selle
         configurée sans recharger porterait le MÊME _bks_id et le gardien
         de panier confondrait les deux groupes. */
      st.code=''; st.printed='';
      showOk(code);
      bn.disabled=false; bn.textContent='🛒 Ajouter au panier';
      paintPrev();
    })
    .catch(function(){ bn.disabled=false; paintPrev(); render(); err("Oups, l'ajout au panier n'a pas fonctionné. Réessaie, et si ça persiste préviens-nous."); });
}

/* ---------- validation & navigation ---------- */
function validate(s){
  if(s===0&&!motoOk())return 'Choisis ton type et remplis la marque, le modèle et l’année.';
  if(s===1&&!st.cout)return 'Choisis un style de couture (ou « Sans décoration »).';
  if(s===1&&!st.fil)return 'Choisis la couleur du fil de couture.';
  if(s===2&&matsList().length===0)return 'Sélectionne au moins une matière.';
  if(s===3&&!(st.cols[0]&&st.cols[1]))return 'Choisis au moins ta couleur principale et ta couleur secondaire.';
  if(s===4&&!brodsOk())return 'Choisis la couleur du fil pour chaque broderie remplie.';
  if(s===5&&!st.desc.trim())return 'Explique-moi ta selle en quelques mots — c’est obligatoire.';
  if(s===5&&!photosOk())return 'Ajoute au moins une photo de ta moto.';
  return null;
}
function firstInvalid(){for(var s=0;s<6;s++)if(validate(s))return s;return -1;}

function tryCheckout(){
  var fi=firstInvalid();
  if(fi>=0){cur=fi;render();paintPrev();err(validate(fi));return;}
  if(!sheetOk()){
    if(cur!==6){cur=6;render();paintPrev();}
    err(st.printed
      ? 'Tu as modifié ta config depuis l’impression : réimprime ta feuille colis avant d’ajouter au panier.'
      : 'Il te manque ta feuille colis ! Imprime-la (bouton ci-dessous) : elle doit être dans le colis avec ta selle, sinon on ne peut pas l’identifier.');
    var b=$('sc-sheetbtn');
    if(b){b.classList.add('shake');setTimeout(function(){b.classList.remove('shake');},700);b.scrollIntoView({behavior:'smooth',block:'center'});}
    return;
  }
  checkout();
}
$('sc-bn').onclick=function(){
  var e=validate(cur);
  if(e){err(e);return;}
  if(cur<STEPS.length-1){cur++;render();paintPrev();window.scrollTo({top:root.offsetTop,behavior:'smooth'});}
  else tryCheckout();
};
$('sc-bp').onclick=function(){if(cur>0){cur--;render();paintPrev();}};
$('sc-cta').onclick=tryCheckout;
$('sc-reset').onclick=function(){
  if(window.confirm('Tout recommencer à zéro ?')){st=blank();cur=0;render();paintPrev();}
};

/* ---------- FAQ / galerie / lightbox ---------- */
var FAQ=[
 ['Comment fonctionne la selle custom ?','Tu configures ta selle ici, tu valides ta commande, puis tu nous envoies ta selle (la base mousse) avec ta feuille colis imprimée. On la recouvre sur mesure selon tes choix, et on te la renvoie prête à poser.'],
 ['Quel est le délai ?','Compte 3 semaines à 1 mois de fabrication, à partir de la réception de ta selle dans notre atelier.'],
 ['Comment vous envoyer ma selle ?','Avant de valider ta commande, tu imprimes ta feuille colis (elle contient ton n° de selle, le récap de tes choix et notre adresse). Une fois ta commande payée, tu notes ton nom et ton n° de commande au stylo dans l’encadré prévu. Tu emballes ta selle dans un carton, tu glisses la feuille à l’intérieur, et tu nous expédies le colis avec le transporteur de ton choix. Adresse de l’atelier : SARL GR France — Bike Sellier, 14 rue Beausoleil, 66380 Pia.'],
 ['Pourquoi la feuille colis est-elle obligatoire ?','C’est le seul moyen d’identifier ta selle quand elle arrive à l’atelier, parmi toutes celles qu’on reçoit. Sans elle, impossible de savoir à qui elle appartient ni quelle configuration appliquer.'],
 ['Et mes photos ?','Tu les ajoutes directement dans le configurateur, à l’étape « Ton projet » : des photos de ta moto + tes inspirations. Elles arrivent avec ta commande, rien à envoyer par email.'],
 ['La « planche déco », c’est quoi ?','C’est une planche imprimée prévue pour la selle, réalisée par ton imprimeur, que tu nous joins dans le colis avec ta selle. Ce n’est PAS le kit déco de ta moto.'],
 ['Comment se passe le paiement ?','Paiement 100 % sécurisé, avec la possibilité de régler en 3 ou 4 fois sans frais.'],
 ['Mes finitions sont-elles garanties ?','Chaque selle est réalisée à la main avec des matières haut de gamme (simili, alcantara). On apporte un soin maximal à chaque finition.']
];
var faqEl=$('sc-faq');
if(faqEl){
  FAQ.forEach(function(qa){
    var it=document.createElement('div'); it.className='faq-item';
    it.innerHTML='<div class="faq-q">'+qa[0]+'<span class="chev">▾</span></div><div class="faq-a">'+qa[1]+'</div>';
    it.querySelector('.faq-q').onclick=function(){it.classList.toggle('open');};
    faqEl.appendChild(it);
  });
}
var gal=$('sc-gallery');
if(gal){
  EXEMPLES.forEach(function(src){
    var g=document.createElement('div'); g.className='g';
    g.style.backgroundImage='url(\''+src+'\')';
    g.onclick=function(){$('sc-lbimg').src=src;$('sc-lbx').classList.add('on');};
    gal.appendChild(g);
  });
  $('sc-lbx').onclick=function(){$('sc-lbx').classList.remove('on');};
}
$('bksmodal').onclick=function(e){if(e.target===this)this.classList.remove('on');};

/* ---------- démarrage ---------- */
tryRestore();
render(); paintPrev();
})();
